import { useEffect } from "react";
import HeaderModal from "../../HeaderModal/HeaderModal";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

export default function ModalTicketConfig({
  open,
  setOpen,
  radioOption,
  setRadioOption,
  isPending,
  chamados,
}: {
  open: boolean,
  setOpen: Function,
  radioOption: string,
  setRadioOption: Function,
  isPending: boolean,
  chamados: any
}) {
  const close = () => {
    setOpen(false);
  };

  const escape = (e: any) => {
    if (e.key === 'Escape') {
      close();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
  }, [escape]);

  const formularios = chamados?.ticketDetails?.formulario;
  const subitem = chamados?.ticketDetails?.subitens;

  return (
    <div className={`modal ${open ? "modal is-active" : "modal"}`} id='esse-aqui' style={{ zIndex: 1000 }}>
      <div className="modal-background" onClick={() => close()} onKeyDown={(eve) => escape(eve)} />
      <div className="modal-card">
        <HeaderModal headerTitle="Exibição de chamados" close={close} />
        <section className="modal-card-body">
          <FormControl disabled={isPending}>
            <FormLabel id="demo-radio-buttons-group-label">Exibição de chamados</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={radioOption}
              name="radio-buttons-group"
            >
              <FormControlLabel value="hide" control={<Radio onChange={(eve) => setRadioOption(eve.target.value)} />} label="Ocultar informações" />
              <FormControlLabel value="some" control={<Radio onChange={(eve) => setRadioOption(eve.target.value)} />} label="Informações essenciais" />
              <FormControlLabel disabled={
                !formularios.some((ele: any) => ele.historicoChamado) ||
                !Object?.values(subitem)?.map((ele: any) => ele?.chamados?.some((elem: any) => elem?.historicoChamado))
              } value="all" control={<Radio onChange={(eve) => setRadioOption(eve.target.value)} />} label="Informações completas" />
            </RadioGroup>
          </FormControl>
        </section>
      </div>
    </div>
  );
}
